module.exports = __webpack_public_path__ + "img/434.695692a0.png";